import API from './axios.js';

export const getTasks = () => API.get('task');
export const getTasksByCourtRef = (courtref) =>API.get(`task/court-ref/${courtref}`);
export const getTaskByID = (id) =>API.get(`/task/${id}`);


export const saveTask = (taskData) => API.post('task', taskData);
export const updateTask = (taskData,id) => API.patch(`task/${id}`, taskData);

export const updateTaskCompletion = (taskId, isCompleted) => API.patch(`task/${taskId}/complete/${isCompleted}`);


export const deleteTask = (id) => API.delete(`task/${id}`);
export const deleteTaskById = (taskId) => API.delete(`task/${taskId}`);

// export const updateTaskStatus = (id,status) => API.patch(`task/${id}/${status}`);
// task/681861d94173abbd7a0c77f2/true


export const getTasksAssignedByUser = (queryParams = '') => API.get(`task/assigned-by-user${queryParams}`);
export const getTasksAssignedToUser = (queryParams = '') => API.get(`task${queryParams}`);


export const getTaskById = (id) => API.get(`task/${id}`);

export const getTasksAssignedByUserId = (userId) => API.get(`tasks/assigned-by/${userId}`);
export const getTasksAssignedToUserId = (userId) => API.get(`tasks/assigned-to/${userId}`);